import React, { useEffect, useState } from "react";
import { getToken } from "../utils/auth";
import { jwtDecode } from "jwt-decode";

function UserDashboard() {
  const [userData, setUserData] = useState({ email: "", role: "" });

  useEffect(() => {
    const token = getToken();
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserData({
          email: decoded.email,
          role: decoded.role,
        });
      } catch (error) {
        console.error("Invalid token", error);
      }
    }
  }, []);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>👋 Welcome to Your Dashboard</h2>
      <p><strong>Email:</strong> {userData.email}</p>
      <p><strong>Role:</strong> {userData.role}</p>

      <div style={{ marginTop: "2rem" }}>
        <h3>Your Purchased Courses (Coming Soon)</h3>
        <p>🎓 You haven't purchased any courses yet.</p>
        {/* Later: Add real course list from backend */}
      </div>
    </div>
  );
}

export default UserDashboard;
